// string constants
const TEXT_MORE = 'more';
const TEXT_LESS = 'less';
// number constants
const ADVANCED_FILTER_BAR_MAX_CHARATER_LENGTH = 2048;
const MEMOIZE_FIELDS_MAX_SIZE = 30;

export { ADVANCED_FILTER_BAR_MAX_CHARATER_LENGTH, MEMOIZE_FIELDS_MAX_SIZE, TEXT_LESS, TEXT_MORE };
//# sourceMappingURL=constants.esm.js.map
